import { TextField } from '@material-ui/core';
import { DragDropContext, Draggable, Droppable } from '@react-forked/dnd';
import {
    onBeforeDragStartHandler,
    onBlurViewName,
    onChangeViewName,
    onChangeViewSelected,
    onDoubleClickView,
    onDragViewEnd,
    onEnterViewName,
    // onWheel,
} from '../handler/ViewHandler';
import SettingView from './SettingView';
import {
    onWheel,
    onTouchEnd,
    onTouchCancel
} from '@/component/ticketKnowledge/handler/ListTicketKnowledgeHandler';
import { useRecoilValue } from 'recoil';
import { corporationAtom } from '@/state/atom/corporationAtom';
import React, { useState } from 'react';  // Add useEffect
import LockIcon from '@material-ui/icons/Lock';
import Constant from '@/common/constant/Constant';
import { visibilityForKnowledgeAtom } from '@/state/atom/ticketAtom';
import { getViewDisplayName, getViewOriginName } from '@/common/utils/ViewUtils';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function DraggableViewsList(props) {
    // Re-render when the translation dictionary loads/extends so view names update.
    useTranslationSubscription();

    const { tabs, viewSelected, element, nodeListView } = props;
    const currentCorporationDetail = useRecoilValue(corporationAtom);
    const visibilityForKnowledgeAtomValue = useRecoilValue(visibilityForKnowledgeAtom);
    const [clickTimeout, setClickTimeout] = useState(null);

    const renderTabName = (view) => {
        let viewName = getViewDisplayName(view);

        return (
            <div
                style={{ width: '100%' }}
                onDoubleClick={() =>
                    onDoubleClickView(view, {
                        ...props,
                        clickTimeout,
                        setClickTimeout
                    })
                }
                data-view-id={view.id}  // Add data attribute for easier targeting
            >
                {!view.isEditName && (
                    <>
                        <div className="info-item-knowledge">
                            <div
                                className="text-icon-container"
                                onClick={() =>
                                    onChangeViewSelected(
                                        view,
                                        { ...props, clickTimeout, setClickTimeout },
                                        currentCorporationDetail
                                    )
                                }
                            >
                                {view.visibleType === Constant.VISIBILITY_SETTING_TYPE.PRIVATE && (
                                    <div className="lock-icon-container">
                                        <LockIcon 
                                            style={{ 
                                                fontSize: '18px', 
                                                color: '#666'
                                            }}
                                            aria-label="Private view"
                                            role="img"
                                        />
                                    </div>
                                )}
                                {view.visibleType === Constant.VISIBILITY_SETTING_TYPE.IN_ORG &&
                                    visibilityForKnowledgeAtomValue ===
                                        Constant.VISIBILITY_SETTING_TYPE.PROJECT && (
                                        <div className="lock-icon-container">
                                            <img
                                            src="/assets/image/building-18_18.svg"
                                            alt="Organization view" 
                                        />
                                    </div>                                     
                                )}
                                <p
                                    className={`tabName-tlt ${viewSelected?.id === view.id && 'title-active'}`}
                                >
                                    {viewName}
                                </p>
                            </div>

                            <SettingView view={view} {...props} />
                        </div>
                    </>
                )}
                {view.isEditName && (
                    <TextField
                        id={view.id}
                        name={view.id}
                        className={`input-view-name ${view.isError ? 'view-name-error' : ''}`}
                        defaultValue={getViewOriginName(view)}
                        onKeyPress={e => onEnterViewName(e, view, props)}
                        onBlur={e => onBlurViewName(e, view, props)}
                        onChange={e => onChangeViewName(e, view, props)}
                        inputRef={props.inputViewNameRef}
                        autoFocus
                        variant="filled"
                        error={view.isError}
                    />
                )}
            </div>
        );
    };

    const renderTabList = droppableProvided => (
        <>
            {tabs.map((item, index) => (
                <Draggable
                    key={item.id}
                    draggableId={item.id + ''}
                    index={index}
                    isDragDisabled={!item?.isMove}
                >
                    {(provided, snapshot) => {
                        
                        if (snapshot.isDragging) {
                            const slider = document.querySelector('.slider-wrapper');
                            let parentOffsetX = 0;

                            if (slider) {
                                const transform = getComputedStyle(slider).transform; 
                                if (transform && transform !== 'none') {
                                    const matrix = transform.match(/matrix.*\((.+)\)/);
                                    if (matrix) {
                                        const values = matrix[1].split(',').map(v => parseFloat(v.trim()));
                                        parentOffsetX = values[4] || 0;
                                        if (parentOffsetX < 0) {
                                            parentOffsetX = - parentOffsetX
                                        }
                                    }
                                }
                            }
                            const style = {...provided.draggableProps.style};
                            const styleLeft = style.left + parentOffsetX - 10;
                            const styleTop = style.top - 42;

                            provided.draggableProps.style.left = styleLeft;
                            provided.draggableProps.style.top = styleTop;
                        }

                        return (
                            <div
                                className={`item item-knowledge ${viewSelected?.id === item.id &&
                                    'active'} ${item.isError ? 'view-error' : ''} ${
                                    index === tabs.length - 1 ? 'item-knowledge-last ' : ''
                                }`}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                data-view-id={item.id}  // Add data attribute for targeting
                            >
                                {renderTabName(item)}
                            </div>
                        )
                    }}
                </Draggable>
            ))}
            {droppableProvided ? droppableProvided.placeholder : null}
        </>
    );

    const renderTabListWrappedInDroppable = () => (
        <DragDropContext
            onBeforeDragStart={e => onBeforeDragStartHandler(e, props)}
            onDragEnd={e => onDragViewEnd(e, props)}
        >
            <Droppable droppableId="viewDropId" direction="horizontal">
                {droppableProvided => (
                    <div
                        id="container-knowledge"
                        onWheel={event => onWheel(event, element, nodeListView, tabs)}
                        onTouchEnd={event => onTouchEnd(event, element, nodeListView, tabs)}
                        onTouchCancel={event => onTouchCancel(event, element, nodeListView, tabs)}
                        ref={droppableProvided.innerRef}
                        {...droppableProvided.droppableProps}
                    >
                        {renderTabList(droppableProvided)}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );

    return renderTabListWrappedInDroppable()
}
